const groupPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE)

export const apiTabletErrors = {
	fetchTabletErrors: async (
		page: number,
		perPage: number,
		statusFilter?: ERecipeErrorStatus[],
		productionDay?: string,
		errorType?: string,
	) => {
		const query: Record<string, any> = {
			page,
			per_page: perPage,
			direction: 'desc',
			sort_by: 'chrono',
		}

		if (statusFilter && statusFilter.length > 0) {
			query['status[]'] = statusFilter
		}

		if (productionDay) {
			query.production_day = productionDay
		}

		if (errorType) {
			query.error_type = errorType
		}

		const { data, meta } = await apiCommon<IApiResponseModel<IRecipeError[]>>(`${groupPrefix}/tablet/errors`, {
			method: 'GET',
			query,
		})

		return {
			data: data.map(toRecipeErrorModel),
			meta,
		}
	},

	fetchTabletErrorTypes: async () => {
		const { data } = await apiCommon<{ data: { value: string; label: string }[] }>(
			`${groupPrefix}/tablet/errors/types`,
			{ method: 'GET' },
		)
		return data
	},

	submitTabletError: async (
		payload: IReportPayload,
		files?: { instructions_preview_img?: File; issue_img?: File },
	) => {
		const hasFiles = Boolean(files?.instructions_preview_img || files?.issue_img)
		if (!hasFiles) {
			return await apiCommon(`${groupPrefix}/tablet/errors`, {
				method: 'POST',
				body: payload,
			})
		}

		const formData = new FormData()
		payload.recipe_ids.forEach(id => formData.append('recipe_ids[]', String(id)))
		payload.meal_ids.forEach(id => formData.append('meal_ids[]', String(id)))
		formData.append('description', payload.description)
		formData.append('type', payload.type)
		formData.append('reporter_name', payload.reporter_name)
		formData.append('socket_id', String(payload.socket_id))
		formData.append('stage_id', String(payload.stage_id))
		formData.append('production_plan_id', String(payload.production_plan_id))
		formData.append('production_simulation_id', payload.production_simulation_id)
		formData.append('view_payload', payload.view_payload)
		if (payload.id !== undefined) formData.append('id', String(payload.id))
		if (payload.name !== undefined) formData.append('name', payload.name)
		if (files?.instructions_preview_img) {
			formData.append('instructions_preview_img', files.instructions_preview_img)
		}
		if (files?.issue_img) {
			formData.append('issue_img', files.issue_img)
		}

		return await apiCommon(`${groupPrefix}/tablet/errors`, { method: 'POST', body: formData }, 'pl', true)
	},

	fetchTabletError: async (errorId: number): Promise<IRecipeErrorModel> => {
		const { data } = await apiCommon<{ data: IRecipeError }>(`${groupPrefix}/tablet/errors/${errorId}`, {
			method: 'GET',
		})
		return toRecipeErrorModel(data)
	},

	addTabletErrorComment: async (errorId: number, payload: IAddCommentPayload): Promise<IAddCommentResponse> =>
		await apiCommon<IAddCommentResponse>(`${groupPrefix}/tablet/errors/${errorId}/comments`, {
			method: 'POST',
			body: payload,
		}),

	markCommentAsReadMes: async (errorId: number, commentId: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/tablet/errors/${errorId}/comments/${commentId}/read/mes`, {
			method: 'POST',
			body: {},
		})
	},

	confirmTabletError: async (errorId: number): Promise<{ data: IRecipeError; message: string }> =>
		await apiCommon<{ data: IRecipeError; message: string }>(`${groupPrefix}/tablet/errors/${errorId}/confirm`, {
			method: 'PATCH',
		}),

	rejectTabletError: async (errorId: number): Promise<{ data: IRecipeError; message: string }> =>
		await apiCommon<{ data: IRecipeError; message: string }>(`${groupPrefix}/tablet/errors/${errorId}/reject`, {
			method: 'PATCH',
		}),

	fetchAvailableTypes: async (payload: IAvailableTypesPayload) => {
		const query: Record<string, any> = {
			simulation_id: payload.simulation_id,
		}

		if ('meal_id' in payload) {
			query.meal_id = payload.meal_id
		}

		if ('increment_ids' in payload && payload.increment_ids.length > 0) {
			query['increment_ids[]'] = payload.increment_ids
		}

		const { data } = await apiCommon<{ data: IAvailableTypesResponse }>(
			`${groupPrefix}/tablet/errors/available-types`,
			{ method: 'GET', query },
		)
		return data
	},
}
